import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { IEmployee, IMonitor } from "./types"
import api from "services/api"
import { IAssignMonitorForm } from "./assign"

export function useExecutionMonitors(
  id: string,
  config?: UseQueryOptions<IMonitor[]>
) {
  return useQuery<IMonitor[]>(
    ["operation", "production", "events", "execution", id, "monitors"],
    config
  )
}

export function useMonitors(
  eventId: string,
  config?: UseQueryOptions<IMonitor[]>
) {
  return useQuery<IMonitor[]>(
    ["operation", "production", "events", eventId, "monitors"],
    config
  )
}

export interface IApplyRequestBody {
  monitorId: string
  transition: string
  attendant_at: string
}

export function useApplyTransition(
  eventId: string,
  config?: UseMutationOptions<unknown, unknown, IApplyRequestBody, unknown>
) {
  const queryClient = useQueryClient()
  return useMutation<unknown, unknown, IApplyRequestBody, unknown>(
    ({ monitorId, ...data }) => {
      return api.post(
        `operation/production/events/execution/${eventId}/monitors/${monitorId}/applyTransition`,
        data
      )
    },
    {
      ...config,
      onSuccess(data, variables) {
        queryClient.invalidateQueries([
          "operation",
          "production",
          "events",
          "execution",
          eventId,
          "monitors",
          variables.monitorId,
          "getTransitions",
        ])
        queryClient.invalidateQueries([
          "operation",
          "production",
          "events",
          "execution",
          eventId,
          "monitors",
        ])
      },
    }
  )
}

export function useExtEmployees(config?: UseQueryOptions<IEmployee[]>) {
  return useQuery<IEmployee[]>(
    ["operation", "administration", "employees", "external"],
    config
  )
}

export function useAssignMonitor(
  eventId: string,
  config?: UseMutationOptions<unknown, unknown, IAssignMonitorForm>
) {
  const queryClient = useQueryClient()
  return useMutation<unknown, unknown, IAssignMonitorForm>(
    (data) =>
      api.post(
        `operation/production/events/execution/${eventId}/monitors`,
        data
      ),
    {
      ...config,
      onSuccess(data, vars, conext) {
        config?.onSuccess?.(data, vars, conext)
        queryClient.invalidateQueries([
          "operation",
          "production",
          "events",
          "execution",
          eventId,
          "monitors",
        ])
      },
    }
  )
}

export function useUnassignExecutionMonitor(
  eventId: string,
  config?: UseMutationOptions<unknown, unknown, string>
) {
  const queryClient = useQueryClient()
  return useMutation(
    (presenceId) =>
      api.delete(
        `operation/production/events/execution/${eventId}/monitors/${presenceId}`
      ),
    {
      ...config,
      onSuccess(data, vars, conext) {
        config?.onSuccess?.(data, vars, conext)
        queryClient.invalidateQueries([
          "operation",
          "production",
          "events",
          "execution",
          eventId,
          "monitors",
        ])
      },
    }
  )
}
